// third-party
import { FormattedMessage } from "react-intl";

// assets
import { CloudDrizzle, ConvertCard, Profile2User } from "iconsax-react";

// type
import { NavItemType } from "types/menu";

// icons
const icons = {
  history: CloudDrizzle,
  version: ConvertCard,
  user: Profile2User,
};

// ==============================|| MENU ITEMS - WIDGETS ||============================== //

const cloudview: NavItemType = {
  id: "group-cloudview",
  title: <FormattedMessage id="page.menu_items_cloudview_label" />,
  icon: icons.history,
  type: "group",
  children: [
    {
      id: "group-cloudview",
      title: <FormattedMessage id="page.menu_items_cloudview_label" />,
      type: "collapse",
      icon: icons.history,
      children: [
        {
          id: "licence-users",
          title: <FormattedMessage id="page.menu_items_cloudview_user_label" />,
          type: "item",
          url: "/users-licence/list",
        },
        {
          id: "licence-history",
          title: (
            <FormattedMessage id="page.menu_items_cloudview_history_label" />
          ),
          type: "item",
          url: "/licence-history",
        },
        {
          id: "licence-version",
          title: (
            <FormattedMessage id="page.menu_items_cloudview_version_label" />
          ),
          type: "item",
          url: "/licence-version/list",
        },
      ],
    },
  ],
};

export default cloudview;
